import React, { useCallback } from 'react';

import { ClinicUserSelect } from '@components/ModelSelect/ClinicUserSelect';
import { OptionType } from '@components/Select';
import { TaskAttributes } from 'chaika-test-attributes';
import { translate } from '@chaika/i18n/helper';
import type { Nullable } from 'chaika-frontend-types/frontend-cms';

interface Props {
    isMultiSelect?: boolean;
    defaultUsers: OptionType<string>[];
    userId?: string | string[];
    dataTest?: string;
    title: string;
    name: string;
    onSelect(option: Nullable<OptionType<string>> | OptionType<string>[], name: string): void;
}

export function ParticipantSelect({
    isMultiSelect,
    defaultUsers,
    userId,
    title,
    name,
    dataTest,
    onSelect,
}: Props): React.ReactElement<any> {
    const tChooseColleague = translate('chooseColleague');

    const onChange = useCallback(
        (option: Nullable<OptionType<string>> | Nullable<OptionType<string>[]>) => {
            if (isMultiSelect) {
                onSelect(option ?? [], name);
            } else {
                onSelect(option, name);
            }
        },
        [isMultiSelect, name, onSelect],
    );

    return (
        <ClinicUserSelect
            forcePlaceholder
            isMultiSelect={isMultiSelect}
            dataTest={dataTest ?? TaskAttributes.ParticipantSelect}
            placeholder={tChooseColleague}
            defaultOptions={defaultUsers}
            userId={userId}
            title={title}
            name={name}
            onChange={onChange}
        />
    );
}
